<template>
  <div id="contenedor-listado-desktop">
    <v-data-table
      :headers="headers"
      :items="usuariosInternos"
      :items-per-page="20">
      <template v-slot:[`item.avatarPublicKey`]="{ item }">
        <v-avatar
          :color="item.avatarPublicKey ? '' : 'primary'"
          size="40">
          <v-img
            v-if="item.avatarPublicKey"
            :src="getAvatarUrl(item.avatarPublicKey)"
            :alt="item.funcionario ? item.funcionario.nombre : ''"></v-img>
          <span v-else class="white--text text-subtitle-1 font-weight-medium">
            {{ getIniciales(item.funcionario ? item.funcionario.nombre : '') }}
          </span>
        </v-avatar>
      </template>
      <template v-slot:[`item.funcionario.nombre`]="{ item }">
        <div>
          <div class="font-weight-medium">
            {{ item.funcionario ? item.funcionario.nombre : '-' }}</div>
          <div class="text-caption grey--text">{{ item.correoElectronico }}</div>
        </div>
      </template>
      <template v-slot:[`item.esSupervisor`]="{ item }">
        <v-tooltip bottom v-if="esSupervisorDeObra(item)">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              class="amber--text text--darken-2">
              fa-hard-hat
            </v-icon>
          </template>
          <span>Supervisa obras</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.roles`]="{ item }">
        <div v-if="item.roles && item.roles.length > 0">
          <v-chip
            small
            :color="getRolColor(item.roles[0])">
            {{ getRolLabel(item.roles[0]) }}
          </v-chip>
          <v-tooltip bottom v-if="item.roles.length > 1">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                small
                v-bind="attrs"
                v-on="on"
                class="ml-1"
                color="grey lighten-2">
                +{{ item.roles.length - 1 }}
              </v-chip>
            </template>
            <div>
              <div v-for="(rol, index) in item.roles.slice(1)" :key="index">
                {{ getRolLabel(rol) }}
              </div>
            </div>
          </v-tooltip>
        </div>
        <span v-else class="grey--text">-</span>
      </template>
      <template v-slot:[`item.estatus`]="{ item }">
        <v-switch
          v-model="item.estatus"
          :true-value="1"
          :false-value="2"
          inset
          @change="preCambiarEstatus(item)">
        </v-switch>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones
          :usuario="item">
        </opciones>
      </template>
    </v-data-table>
    <v-dialog
      v-if="usuarioSeleccionado"
      v-model="editarUsuarioDialog"
      width="600">
      <v-card>
        <v-card-title class="secondary--text">
          Cambiar Estatus Usuario
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrarEditarUsuarioDialog">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-area
            cols="12"
            v-model="comentarios"
            label="Comentarios"
            autoGrow>
          </custom-text-area>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrarEditarUsuarioDialog"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="cambiarEstatus"
            :disabled="enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ACTUALIZAR_ESTATUS_USUARIO from '@/graphql/mutations/administracion/catalogos/usuarios/actualizarEstatusUsuario.gql';
import USUARIOS from '@/graphql/querys/administracion/catalogos/usuarios/usuarios.gql';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';
import Opciones from './Opciones.vue';

export default {
  name: 'ListadoDesktop',
  components: {
    CustomTextArea,
    CustomButton,
    Opciones,
  },
  props: {
    usuarios: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      enviandoFormulario: false,
      headers: [
        {
          text: '',
          value: 'avatarPublicKey',
          sortable: false,
          width: '60px',
        },
        { text: 'Funcionario', value: 'funcionario.nombre', sortable: false },
        {
          text: 'Supervisor',
          value: 'esSupervisor',
          sortable: false,
          width: '100px',
          align: 'center',
        },
        {
          text: 'Roles', value: 'roles', sortable: false, width: '180px',
        },
        {
          text: 'Estatus', value: 'estatus', sortable: false, width: '120px',
        },
        { text: 'Comentarios', value: 'comentarios', sortable: false },
        {
          text: '', align: 'end', value: 'acciones', sortable: false, width: '80px',
        },
      ],
      usuarioSeleccionado: null,
      editarUsuarioDialog: false,
      comentarios: null,
    };
  },
  computed: {
    usuariosInternos() {
      // Filtrar solo usuarios internos (que tengan funcionario y no contratista)
      return this.usuarios.filter((usuario) => usuario.funcionario && !usuario.contratista);
    },
  },
  methods: {
    getRolColor(rol) {
      const colores = {
        admin: 'error',
        supervisor: 'warning',
        operador: 'info',
        consulta: 'grey',
      };
      return colores[rol] || 'primary';
    },
    getRolLabel(rol) {
      const labels = {
        admin: 'Administrador',
        supervisor: 'Supervisor',
        operador: 'Operador',
        consulta: 'Consulta',
      };
      return labels[rol] || rol;
    },
    getIniciales(nombreCompleto) {
      if (!nombreCompleto) return '?';
      const palabras = nombreCompleto.trim().split(' ');
      if (palabras.length === 1) {
        return palabras[0].substring(0, 2).toUpperCase();
      }
      return (palabras[0].charAt(0) + palabras[palabras.length - 1].charAt(0)).toUpperCase();
    },
    getAvatarUrl(publicKey) {
      // Ajusta esta URL según tu configuración de storage
      return `${process.env.VUE_APP_STORAGE_URL || '/storage'}/${publicKey}`;
    },
    esSupervisorDeObra(usuario) {
      return usuario.funcionario && usuario.funcionario.esSupervisor;
    },
    cerrarEditarUsuarioDialog() {
      this.editarUsuarioDialog = false;
      this.comentarios = null;
      this.usuarioSeleccionado = null;
    },
    preCambiarEstatus(usuarioEditar) {
      this.usuarioSeleccionado = usuarioEditar;
      this.editarUsuarioDialog = true;
    },
    cambiarEstatus() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const { id, estatus } = this.usuarioSeleccionado;
      const usuario = {
        estatus: !estatus ? 2 : estatus,
        comentarios: this.comentarios,
      };
      this.$apollo
        .mutate({
          mutation: ACTUALIZAR_ESTATUS_USUARIO,
          variables: { id, usuario },
          update: (cache, { data: { actualizarEstatusUsuario } }) => {
            const data = cache.readQuery({ query: USUARIOS });
            const { usuarios } = data;
            const index = usuarios.findIndex((item) => item.id === id);
            usuarios.splice(index, 1, actualizarEstatusUsuario);
            cache.writeQuery({ query: USUARIOS, data });
            this.cerrarEditarUsuarioDialog();
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
    },
  },
};
</script>

<style lang="scss">

</style>
